// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3kT6r","colMin":"styles_colMin__3y0zM","colCheckbox":"styles_colCheckbox__2EueB"};